<template>
  <div class="comReport">
    <div class="module">
      <div class="module">
        <inpBox
          title="联系人"
          :showRight="false"
          keyName="complainant"
          @onInput="onInput"
          @blur="blur"
          :inpval="postInfo.complainant"
        ></inpBox>
        <inpBox
          title="联系电话"
          :showRight="false"
          keyName="phoneNo"
          @onInput="onInput"
          @blur="blur"
          :inpval="postInfo.phoneNo"
        ></inpBox>
        <inpBox
          v-if="common.userTenantInfo.userName"
          title="我的企业"
          inpBoxType="select"
          @select="select('userTenantInfo')"
          :selectValue="postInfo.lesseeName"
        ></inpBox>
        <inpBox
          v-if="complainTypeList.length!=0"
          title="投诉类型"
          inpBoxType="select"
          :border="border"
          @select="select('complainType')"
          :selectValue="complainTypeText"
        ></inpBox>
      </div>
    </div>

    <div class="module">
      <div class="titleOther">
        <span class="Must">*</span>投诉内容
      </div>
      <textarea
        maxlength="140"
        class="textarea"
        name="name"
        rows="8"
        cols="80"
        placeholder="请输入不少于10字描述"
        v-model="postInfo.complainContent"
        @blur="blur"
      ></textarea>
    </div>
    <div class="module">
      <div class="titleOther">
        <span class="Must Mustno">*</span>上传照片
        <span class="titleOther_tips">（选填）</span>
      </div>
      <div class="pic">
        <div
          class="addPic"
          v-for="(item,index) in fileList"
          @click="viewImage(item.path,index)"
          :key="item.path"
        >
          <img class="video" :src="item.path" />
          <img
            class="deleteFile"
            @click.stop="deleteFile(item)"
            src="../../assets/images/btn_clear.png"
          />
        </div>
        <!-- <template v-if="fileList && fileList.length < 9">
        <a-upload ref="upload" id="upload" name="files" :action="url" :headers="headersAnt" :data="{
            'target': targetId,
            'moduleCode': 'TM',
            'platform': 'SaasMobile',
            'timestamp': timemap,
            'sign':hex_md5_return,
            'companyId':common.userInfo.cityId
          }" listType="picture-card" :showUploadList="false" :beforeUpload="beforeUpload"
          @preview="handlePreview" @change="handleChangeVideo" accept="image/*" :remove="remove" :multiple="true" style="display:inline-block;background:#fff;border-radius:8px;display:flex;align-items:center;">
          <div class="addPic" @click="getInp">
            <a-icon type="plus" class="add_icon"/>
          </div>
        </a-upload>
        </template>-->
        <div class="addPic">
          <img class="addImg" src="../../assets/images/repair/add.png" alt />
          <input
            class="file"
            name="files"
            type="file"
            id="fileInput"
            :multiple="true"
            accept="image/*"
            @change="change"
          />
        </div>
      </div>
      <!-- <p class="tips">* 建议照片数量不超过5张，以保证最佳使用效果。</p> -->
    </div>

    <mt-popup v-model="popupVisible" position="bottom" class="mint-popup">
      <mt-picker
        class="picker"
        :slots="dataList"
        @change="onValuesChange"
        :visible-item-count="5"
        :show-toolbar="true"
        ref="picker"
      >
        <div class="picker_wrap">
          <div class="picker_btn" @click="popupVisible=false">取消</div>
          <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
      </mt-picker>
    </mt-popup>

    <div class="btnWrap_h"></div>
    <div class="bottomBtn_wrap">
      <div
        :class="['btn',postInfo.complainant!=''&&postInfo.phoneNo!=''&&postInfo.complainType!=''&&postInfo.complainContent!=''?'bottomBtn':'']"
        @click="submit"
      >提交</div>
    </div>
    <!-- 查看大图 -->
    <fade-animation>
      <common-gallary
        :imgs="arrImgs"
        :curIndex="curIndex"
        v-show="showGallary"
        @close="showGallary=false"
      ></common-gallary>
    </fade-animation>
  </div>
</template>

<script>
// function getBase64(img, callback) {
//   const reader = new FileReader()
//   reader.addEventListener('load', () => callback(reader.result))
//   reader.readAsDataURL(img)
// }
var canvas = document.createElement('canvas');
var ctx = canvas.getContext('2d');
//canvas
var tCanvas = document.createElement('canvas');
var tctx = tCanvas.getContext('2d');
import CommonGallary from "../../components/Gallary";
import FadeAnimation from "../../components/FadeAnimation";
import inpBox from '../../components/inpBox';
import util from '../../utils/util';
import Exif from 'exif-js'
// import wx from 'weixin-js-sdk'
import {
  spaceUpPcHttp,
  callSpaceUp
} from '../../utils/api';
import {
  mapState
} from 'vuex';
export default {
  name: 'comReport',
  props: {},
  components: {
    CommonGallary,
    FadeAnimation,
    inpBox
  },
  filters: {
    toDate: function (value) {
      return util.formatTime(new Date(value), 4);
    },
  },
  computed: {
    ...mapState({
      userId: state => state.common.userId,
      common: state => state.common
    })
  },
  data() {
    return {
      failTimes: 0,//上传失败的图片
      uploadTimes: 0,//上传的张数
      arrImgs: [],
      curIndex: 0,
      showGallary: false,
      fangList: [],//房源列表
      selectItemArr: [],//选择的房源数组

      removeSomeUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/removeSomeAttachment',
      searchFileUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/queryAttachmentListByOneData',
      changeTargetIdUrl: spaceUpPcHttp + '/syscfg/attachmentTerminal/bindSomeAttachments',
      timemap: "",
      loading: false,
      url: spaceUpPcHttp + '/syscfg/attachmentTerminal/uploadFile',
      headersAnt: {
        "Access-channel": "saas_rst",
      },
      headers: {
        "Access-channel": "saas_rst",
        // "Content-type":'multipart/form-data'
      },
      targetId: new Date().getTime(),
      remove: (res) => {
        this.deleteList.push(res.uid)
      },
      fileList: [],
      fileList_before: [],
      selectType: "", //选择类型
      border: false,
      maxsize: 1000 * 1024,
      popupVisible: false,
      popupVisible_fang: false,
      dataList: [],
      contractList: [],
      videoList: [],
      imgUrlList: [],
      postInfo: {
        complainant: "",//	true	普通参数	string		投诉人
        followUserId: "",//	true	普通参数	int		跟进人id
        followUserName: "",//	true	普通参数	string	默认是自己	跟进人
        phoneNo: "",//	true	普通参数	string		联系电话
        complainType: "",//	true	普通参数	string	默认第一个	投诉类型
        complainContent: "",//	true	普通参数	string		投诉内容

        complainSource: "3",//	true	普通参数	string	来源写死 系统	投诉来源
        renter: "",//	true	普通参数	int		是否租客 1是2不是
        lesseeId: "",//	true	普通参数	int		租客id
        lesseeName: "",//	true	普通参数	string		租客名

        projectId: "",//	true	普通参数	int		项目id
        subProjectId: "",//	true	普通参数	int	默认第一个	子项目id
        companyId: "",//	true	普通参数	string		公司id
        platform: "",//	true	普通参数	string	默认 RST	平台
        thirdId: "",//	true	普通参数	string		星商汇用户id
      },

      projectTypeList: [{
        flex: 1,
        values: [],
        className: 'slot1',
        textAlign: 'center'
      }],
      projectType: [],
      repairTypeList: [
        // {
        //   flex: 1,
        //   values: ['装修', '排水' ,'暖通','强电','弱电','消防','电梯','照明','空调设施'],
        //   className: 'slot1',
        //   textAlign: 'center'
        // }
      ],
      repairType: [
        // {
        //   code: "1",
        //   flag: false,
        //   id: 4731,
        //   text: "装修",
        //   typeId: 403,
        //   value: "1"
        // }
      ],
      complainType: [],//	true	普通参数	string	默认第一个	投诉类型
      complainTypeText: "",
      complainTypeList: [

      ],//	true	普通参数	string	默认第一个	投诉类型
      complainSource: [],//	true	普通参数	string	来源写死 系统	投诉来源
      userTenantInfo: [],
      userTenantInfoList: [],
    };
  },
  created() {
    // this.postInfo.expectTime = util.formatTime(new Date(),10);
    this.postInfo.complainant = this.common.userInfo.userName
    this.postInfo.phoneNo = this.common.userInfo.account
    this.postInfo.subProjectName = this.common.marketInfo.marketName
    this.postInfo.subProjectId = Number(this.common.marketInfo.id)
    this.postInfo.projectId = Number(this.common.marketInfo.cityId)
    this.postInfo.thirdId = this.userId
    this.postInfo.platform = "RST"
    this.postInfo.companyId = this.common.userInfo.cityId
    this.postInfo.url = "/property/rstRepair/createOrUpdateComplainHeader"

    if (this.common.userTenantInfo.userName) {
      console.log("this.common")
      console.log(this.common)
      this.postInfo.renter = 1
      this.userTenantInfo = this.common.userTenantInfoList
      this.postInfo.complainant = this.common.userTenantInfo.userName
      let arr = []
      for (let i = 0; i < this.common.userTenantInfoList.length; i++) {
        if (this.common.userTenantInfoList[i].status == 1) {
          arr.push(this.common.userTenantInfoList[i].company)
        }
      }
      this.postInfo.lesseeName = this.common.userTenantInfo.company
      this.postInfo.lesseeId = this.common.userTenantInfo.companyId
      // this.postInfo.lesseeId = this.common.userTenantInfoList[0].id
      // this.postInfo.lesseeName = this.common.userTenantInfoList[0].company
      this.userTenantInfoList = [{
        flex: 1,
        values: arr,
        className: 'slot1',
        textAlign: 'center'
      }]
      console.log("userTenantInfoList")
      console.log(this.userTenantInfoList)
    } else {
      this.postInfo.renter = 2
    }
    this.resetSign()
  },
  mounted() {

  },
  activated() {
    // this.getSubProjectList();
    // this.getRepairType();
    this.getComplainType();
    // this.postInfo.repairType = ""
    // this.postInfo.repairTypeId = ""
    // this.postInfo.address = ""
    // this.postInfo.remark = ""
  },
  methods: {
    beforeUpload(file) {
      console.log(file)
      this.uploadTimes = this.uploadTimes + 1
      let size = file.size / 1024 / 1024;
      let isLt20M = size < 20;
      if (size >= 20) {
        util.showToast('文件超过20mb', 3000)
        return false;
      }
      if (this.fileList && this.fileList.length > 8) {
        util.hideLoading()
        util.showToast('最多上传9张照片')
        return false;
      }
      return isLt20M;
    },
    resetSign() {
      // 公钥+私钥+时间戳+平台
      let gong = 'vanke2019spaceup009'
      let si = '009vanke2019spaceup001'
      this.timemap = new Date().getTime()
      let platfrom = 'SaasMobile'
      let str = gong + si + this.timemap + platfrom
      this.hex_md5_return = this.$md5(str)
      this.currentDate = util.formatTime(new Date(), 10)
    },
    getInp() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        let upload = document.querySelector('input')
        upload.click();
        this.resetSign();
      }
    },
    deleteFile(item) {
      let self = this;
      fetch(self.removeSomeUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          "Access-channel": "saas_rst",
          "companyId": self.common.userInfo.cityId
        },
        body: JSON.stringify({
          'ids': item.id,
          'platform': 'SaasMobile',
          'timestamp': self.timemap,
          'sign': self.hex_md5_return,
          'companyId': self.common.userInfo.cityId
        })
      }).then(response => response.json()).then(res => {
        console.log(res)
        for (var i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].id == item.id) {
            this.fileList.splice(i, 1)
          }
        }
        this.fileList.forEach((item, i) => {
          if (item.postfix.indexOf('image') > -1) {
            this.$set(this.arrImgs, i, item.path)
          }
        })
      })
    },
    changeTarget(id) {
      let self = this;
      this.resetSign()
      fetch(self.changeTargetIdUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          "Access-channel": "saas_rst",
          "companyId": self.common.marketInfo.cityId
        },
        body: JSON.stringify({
          'newTarget': id,
          'oldTarget': self.targetId,
          'bizCode': 'TM',
          'platform': 'SaasMobile',
          'timestamp': self.timemap,
          'sign': self.hex_md5_return,
          'companyId': self.common.marketInfo.cityId
        })
      }).then(response => response.json()).then(res => {
        console.log("替换成功")
        console.log(res)
      })
    },
    handlePreview() {

    },
    handleChangeVideo(info) {
      util.showLoading("正在上传...");
      if (info.file.status === 'error') {
        this.loading = false
        this.failTimes = this.failTimes + 1
        this.uploadTimes = this.uploadTimes - 1
        if (this.uploadTimes == 0) {
          util.hideLoading()
        }
      } else if (info.file.status === 'uploading') {
        this.loading = true
        // setTimeout(function(){
        //   util.hideLoading()
        // },10000)
        return
      } else if (info.file.status === 'done') {
        if (info.file.response.code == 1000) {
          // Get this url from response in real world.
          // getBase64(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = info.file.response.data[0].url
          this.loading = false
          this.uploadTimes = this.uploadTimes - 1;
          if (this.uploadTimes == 0) {
            util.hideLoading()
          }
          this.fileList.push({
            id: info.file.response.data[0].id,
            uid: info.file.uid,
            name: info.file.name,
            status: 'done',
            path: this.imageUrl,
            postfix: info.file.type
          })
          if (this.failTimes > 0) {
            util.showToast('上传失败' + this.failTimes + '张')
            this.failTimes = 0
          }
        } else {
          this.loading = false
          if (info.file.response.msg) {
            util.showToast(info.file.response.msg)
          } else {
            util.showToast('接口返回上传失败')
          }
          util.hideLoading()
        }
        // })
      } else {
        util.hideLoading()
      }
    },
    blur() {
      setTimeout(function () {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    onInput(event) {
      this.postInfo[event.keyName] = event.val
    },
    viewVideo(url) {
      this.$router.push(`/viewVideo?url=${url}`);
    },
    viewImage(url, index) {
      console.log(index)
      this.fileList.forEach((item, i) => {
        this.$set(this.arrImgs, i, item.path)
      })
      this.curIndex = index
      this.showGallary = true
    },
    change(val) {
      let that = this;
      let Orientation = '';
      let mess = val.target.files;
      var files = Array.prototype.slice.call(mess);
      if (files.length + this.fileList.length > 9) {
        util.showToast('最多只可上传9张图片')
        return false;
      }
      util.showLoading()
      files.forEach(function (file, i) {
        if (!/\/(?:jpeg|png|gif)/i.test(file.type)) return;
        //去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, 'Orientation');
        });
        var reader = new FileReader();
        reader.onload = function () {
          var result = this.result;
          var img = new Image();
          img.src = result;
          // 如果图片大小小于1000kb，则直接上传
          if (result.length <= that.maxsize) {
            img = null;
            that.upload(result, file.type, file.name);
            return;
          }
          //      图片加载完毕之后进行压缩，然后上传
          if (img.complete) {
            callback();
          } else {
            img.onload = callback;
          }
          function callback() {
            var data = that.compress(img, Orientation);
            that.upload(data, file.type, file.name);
            img = null;
          }
        };
        reader.readAsDataURL(file);
      })
    },
    onValuesChange(picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    handleConfirm() {
      this.popupVisible = false
      let valve = this.$refs.picker.getValues()[0];
      if (this.selectType == 'complainType') {
        for (let i = 0; i < this.complainType.length; i++) {
          if (this.complainType[i].text == valve) {
            this.postInfo.complainType = this.complainType[i].code
            this.complainTypeText = this.complainType[i].text
          }
        }
      } else if (this.selectType == 'userTenantInfo') {
        for (let i = 0; i < this.userTenantInfo.length; i++) {
          if (this.userTenantInfo[i].company == valve) {
            this.postInfo.lesseeId = this.userTenantInfo[i].companyId
            this.postInfo.lesseeName = this.userTenantInfo[i].company
          }
        }

      }
    },
    select(type) {
      this.popupVisible = true;
      this.selectType = type
      if (type == 'complainType') {
        this.dataList = this.complainTypeList;
      } else if (type == 'userTenantInfo') {
        this.dataList = this.userTenantInfoList
      }
    },
    details(item) {
      this.$router.push(`/comReportingDetails?id=${item.localId}&contNo=${item.contNo}`);
    },
    submit() {
      let self = this;

      if (this.postInfo.complainant == '') {
        util.showToast('联系人不能为空')
        return;
      }
      if (this.postInfo.phoneNo == '') {
        util.showToast('联系人电话不能为空')
        return;
      }
      if (this.postInfo.renter == 1 && this.postInfo.lesseeId == '') {
        util.showToast('我的企业不能为空')
        return;
      }
      if (this.complainTypeList.length && this.postInfo.complainType == '') {
        util.showToast('投诉类型不能为空')
        return;
      }
      if (this.postInfo.complainContent == '') {
        util.showToast('投诉内容不能为空')
        return;
      }
      let conStr = this.postInfo.complainContent.trim().length
      if (conStr < 10) {
        util.showToast('投诉内容不能少于10个字')
        return;
      }
      console.log(self.postInfo)
      // return;
      util.showLoading("正在提交...");
      callSpaceUp(self.postInfo).then(res => {
        console.log(res);
        util.hideLoading();
        if (res.res.code == 10000) {
          let id = res.body.data.id
          this.changeTarget(id)
          this.$router.replace(`/sublimeSuccess?id=${id}&title=查看投诉建议`);
        }
      });
    },
    getSubProjectList() {
      // let parmes = {
      //   thirdId: this.userId,
      //   platform: "RST",
      //   companyId: this.common.userTenantInfo.companyId?this.common.userTenantInfo.companyId:'',
      //   url: "/property/rstRepair/getSubProjectList"
      // }
      // callSpaceUp(parmes).then(res => {
      //   console.log("项目列表");
      //   console.log(res);
      //   if (res.res.code == 10000) {
      //     this.projectType = res.body.data
      //     // this.spaceRelBeans.subProjectName = this.projectType[0].subProjectName
      //     // this.spaceRelBeans.subProjectId = this.projectType[0].id
      //     // this.spaceRelBeans.projectId = this.projectType[0].projectId
      //     var arr = []
      //     for (let i = 0; i < res.body.data.length; i++) {
      //       arr.push(res.body.data[i].subProjectName)
      //     }
      //     this.projectTypeList = [{
      //       flex: 1,
      //       values: arr,
      //       className: 'slot1',
      //       textAlign: 'center'
      //     }]
      //     console.log(this.projectTypeList);
      //   }
      // });
    },
    getComplainType() {
      let parmes = {
        companyId: this.common.userInfo.cityId,
        url: "/property/rstRepair/initDictWhenLoginName"
      }
      callSpaceUp(parmes).then(res => {
        console.log("投诉类型");
        console.log(res);
        console.log(res.body.data.complain_type);
        if (res.res.code == 10000) {
          this.complainType = res.body.data.complain_type
          let arr = []
          for (let i = 0; i < this.complainType.length; i++) {
            arr.push(this.complainType[i].text)
          }
          this.postInfo.complainType = this.complainType[0].code
          this.complainTypeText = this.complainType[0].text
          this.complainTypeList = [{
            flex: 1,
            values: arr,
            className: 'slot1',
            textAlign: 'center'
          }]
          console.log(this.complainTypeList);
        }
      });
    },
    // 图片上传，将base64的图片转成二进制对象，塞进formdata上传
    upload(basestr, type, name) {
      let self = this;
      this.resetSign()
      var text = window.atob(basestr.split(',')[1]);
      var buffer = new Uint8Array(text.length);
      for (var i = 0; i < text.length; i++) {
        buffer[i] = text.charCodeAt(i);
      }
      var blob = this.getBlob([buffer], type);
      var formdata = new FormData();
      console.log(blob)
      formdata.append('files', blob, '1.jpg');// 传文件
      formdata.append('target', self.targetId);
      formdata.append('moduleCode', "TM");
      formdata.append('platform', "SaasMobile");
      formdata.append('timestamp', self.timemap);
      formdata.append('sign', self.hex_md5_return);
      formdata.append('companyId', self.common.marketInfo.cityId);
      util.showLoading('上传中...')
      fetch(self.url, {
        method: 'post',
        body: formdata,
        headers: self.headersAnt
      }).then(response => response.json()).then(res => {
        console.log(res)
        if (res.code == 1000) {
          util.hideLoading()
          this.fileList.push({
            id: res.data[0].id,
            path: res.data[0].url
          })
        } else {
          util.showToast('图片上传失败')
          util.hideLoading()
        }
      })
    },
    getBlob(buffer, format) {
      try {
        return new Blob(buffer, { type: format });
      } catch (e) {
        var bb = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MSBlobBuilder)();
        buffer.forEach(function (buf) {
          bb.append(buf);
        });
        return bb.getBlob(format);
      }
    },
    compress(img, Orientation) {
      var initSize = img.src.length;
      var width = img.width;
      var height = img.height;
      // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      var ratio;
      if ((ratio = width * height / 4000000) > 1) {
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      // 如果图片像素大于100万则使用瓦片绘制
      var count;
      if ((count = width * height / 1000000) > 1) {
        count = ~~(Math.sqrt(count) + 1); // 计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        var nw = ~~(width / count);
        var nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (var i = 0; i < count; i++) {
          for (var j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6://需要顺时针（向左）90度旋转
            this.rotateImg(img, 'left', canvas);
            break;
          case 8://需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas);
            break;
          case 3://需要180度旋转
            this.rotateImg(img, 'right', canvas);//转两次
            this.rotateImg(img, 'right', canvas);
            break;
        }
      }
      // 进行最小压缩
      var ndata = canvas.toDataURL('image/jpeg', 0.6);
      console.log('压缩前：' + initSize);
      console.log('压缩后：' + ndata.length);
      console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + '%');
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == 'right') {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = step * 90 * Math.PI / 180;
      let ctx = canvas.getContext('2d');
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.comReport {
  width: 100%;
  overflow-x: hidden;
  background: rgba(237, 237, 237, 1);
  .module {
    margin-bottom: 14px;
    .selectBottom {
      height: 80px;
      width: 100%;
      background: #fff;
      border-bottom: 1px solid #eaeaea;
      display: flex;
      align-items: center;
      .selectTab {
        display: flex;
        align-items: center;
        padding: 0 20px;
      }
      .tag {
        width: 140px;
        margin-right: 10px;
        height: 48px;
        background: rgba(243, 245, 253, 1);
        border-radius: 4px;
        // border: 1px solid rgba(150,170,240,1);
        .border(rgba(150,170,240,1));
        font-size: 24px;
        color: rgba(23, 64, 218, 1);
        text-align: center;
        line-height: 48px;
      }
    }
  }
  .titleOther {
    height: 100px;
    background-color: #fff;
    padding: 0 20px;
    display: flex;
    align-items: center;
  }
  .Must {
    font-size: 28px;

    color: rgba(252, 63, 86, 1);
    display: inline-block;
    line-height: 100px;
  }
  .Mustno {
    color: #fff;
  }
  .titleOther_tips {
    color: #9d9d9d;
    font-size: 28px;
  }
  .textarea {
    width: 100%;
    height: 182px;
    padding: 0 40px;
    box-sizing: border-box;
    font-size: 28px;

    color: #333333;
  }
  // .addPic_wrap{
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   width: 160px;
  //   height: 160px;
  //   background: rgba(244,244,244,1);
  // }
  .pic {
    flex: 1;
    background: #fff;
    padding: 0 30px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    .addPic {
      width: 160px;
      height: 160px;
      background: rgba(244, 244, 244, 1);
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-bottom: 20px;
      margin-right: 20px;
      .video_icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 68px;
        height: 68px;
      }
      .video {
        width: 160px;
        height: 160px;
      }
      .addImg {
        width: 28px;
        height: 28px;
      }
      .file {
        position: absolute;
        width: 160px;
        height: 160px;
        opacity: 0;
      }
      .deleteFile {
        position: absolute;
        right: -25px;
        top: -25px;
        width: 50px;
        height: 50px;
      }
    }
  }
  .tips {
    color: #fc3f56;
    font-size: 20px;
    line-height: 30px;
    padding: 0 30px 20px;
    background: #fff;
  }
  .btnWrap_h {
    width: 100%;
    height: 108px;
  }

  .bottomBtn_wrap {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 108px;
    background: #fff;
    .btn {
      width: 694px;
      height: 76px;
      background: rgba(218, 218, 218, 1);
      border-radius: 4px;
      margin: 16px 28px;
      font-size: 32px;

      text-align: center;
      line-height: 76px;
      color: #fff;
    }
    .bottomBtn {
      background: #1740da;
      color: #fff;
    }
  }

  .inpBox {
    width: 100%;
    height: 100px;
    border-bottom: 1px solid #eaeaea;
    background: #fff;
    display: flex;
    padding: 0 20px;
    box-sizing: border-box;
    align-items: center;
    z-index: 99;
    .Must {
      font-size: 28px;

      color: rgba(252, 63, 86, 1);
      display: inline-block;
      line-height: 100px;
    }
    .Mustno {
      color: #fff;
    }
    .title {
      width: 120px;
      text-align: left;
      font-size: 28px;

      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      margin-left: 4px;
    }
    .inpWrap {
      flex: 1;
      padding-left: 60px;
      display: flex;
      .inp {
        flex: 1;
        font-size: 28px;

        color: rgba(51, 51, 51, 1);
      }
      .selectValue_p {
        color: #c9c9c9;
      }
    }
    .rightIcon {
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
  }
  .inpBox_noBorder {
    border-bottom: none;
  }
  .ant-upload {
    width: 160px;
    height: 160px;
    background: rgba(244, 244, 244, 1);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 20px;
    margin-right: 20px;
  }
}
.ant-upload-btn {
  width: 170px !important;
  height: 170px !important;
  background: red !important;
}
// 选择房源
.fang {
  width: 750px;
  height: 608px;
  background: #fff;
  .fang_title {
    display: flex;
    align-items: center;
    height: 80px;
    .fang_title_1,
    .fang_title_3 {
      padding: 20px 28px;
      font-size: 28px;

      color: rgba(51, 51, 51, 1);
      line-height: 40px;
      text-align: center;
    }
    .fang_title_2 {
      flex: 1;
      height: 44px;
      font-size: 32px;

      color: rgba(51, 51, 51, 1);
      line-height: 44px;
      text-align: center;
    }
    .fang_title_3 {
      color: #1740da;
    }
  }
  .fangCon {
    height: 520px;
    overflow-y: scroll;
    padding-top: 24px;
    padding-bottom: 24px;
    box-sizing: border-box;
    .fangCon_item {
      height: 80px;
      display: flex;
      align-items: center;
      padding-left: 28px;
      box-sizing: border-box;
      .fangCon_item_1 {
        width: 36px;
        height: 36px;
        margin-right: 20px;
        border: 2px solid rgba(218, 218, 218, 1);
        box-sizing: border-box;
        border-radius: 50%;
      }
      .fangCon_item_1_img {
        width: 36px;
        height: 36px;
        margin-right: 20px;
        border-radius: 50%;
      }
      .fangCon_item_2 {
        flex: 1;
        height: 44px;
        font-size: 32px;

        color: rgba(51, 51, 51, 1);
        line-height: 44px;
      }
    }
  }
}
.add_icon {
  font-size: 50px;
  color: #999;
}
</style>
